<!-- 首页 -->

<template>
  <div class="system-container">
    <div class="head">
      <span class="unified-module-title">校园智慧管理系统<strong class="header-strong">(专利保护，仿冒必究)</strong></span>
      <p style="color:#333;font-size:18px;font-weight: bold;">汇集校园万物智能互联</p>
    </div>
    <div class="content">
      <ul>
        <li v-for="item in plans" :key="item.id">
          <a :href="'/system_scheme/'+item.id">
            <div style="text-align:center;">
              <img :src="item.icon" alt style="margin-bottom:5px;" width="65" height="65">
            </div>
            <h2 class="plan-name">{{item.title}}</h2>
          </a>
          <div class="plan-intro">
            <span v-html="item.intro">{{item.intro}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped>
.system-container {
  width: 100%;
  height: 100%;
}
.head {
  width: 100%;
  text-align: center;
}
.header-strong{
  color: blue;
  font-size: 16px;
}

.content {
  width: 1200px;
  /* height: 400px; */
  /* border: 1px solid black; */
  margin: 15px auto;
  overflow: hidden;
}
.content ul {
  width: 1280px;
}
.content ul li {
  width: 300px;
  height: 150px;
  margin-bottom: 20px;
  /* border: 1px solid black; */
  float: left;
  padding: 30px 20px 0px 0px;
  box-sizing: border-box;
}
.plan-name {
  font-size: 18px;
  text-align: center;
  transition: 0.2s;
}
.content ul li a:hover .plan-name {
  color: #3b94e3;
}
.plan-intro {
  text-align: center;
  font-size: 12px;
  color: #666;
  margin-top: 3px;
  line-height: 1.4;
}
/* .plan-name:hover {
} */
</style>
<script>
export default {
  name: "systemContainer",
  data() {
    return {
      /**
       * name 系统名称
       * intor 系统简介
       * icon 系统样式图标
       * href:点击后的跳转链接
       */
      plans: [
        {
          name: "校园计算机智慧网络系统",
          intro: "18个学院通过一条光纤传输",
          icon: require("../assets/system/network.png"),
          href: "###"
        },
        {
          name: "校园动态人脸识别通系统",
          intro: "把全校师生三维立体脸谱录入数据库，作人脸识别数据",
          icon: require("../assets/system/faceRecognition.png"),
          href: ""
        },
        {
          name: "校园电器设备使用智能化控制系统",
          intro:
            "把全校灯，风扇，电脑，空调机，饮水机，办公设备装置智能开关由计算机控制使用",
          icon: require("../assets/system/intelligent.png"),
          href: ""
        },
        {
          name: "全校智能电子锁匙系统",
          intro: "密码，指纹，人脸识别，手机App，，计算机控制，门卫锦襄开锁",
          icon: require("../assets/system/sLock.png"),
          href: ""
        },
        {
          name: "课室智能消毒，灭蚊系统",
          intro: "有效解决学生手足口病、流感、登革热等传染病菌源",
          icon: require("../assets/system/disinfection.png"),
          href: ""
        },
        {
          name: "课室空气智能净化系统",
          intro: "自动开启空气净化系统设备及自动抽风设备，保证课室空气清新",
          icon: require("../assets/system/airPurification.png"),
          href: ""
        },
        {
          name: "学生进校体温自动检测系统",
          intro: "对体温超38度的学生进校门时捡测器会自动报警",
          icon: require("../assets/system/temperature.png"),
          href: ""
        },
        {
          name: "校园特别情况应急对讲系统",
          intro: "校园遇特别情况时图像声音对讲处理",
          icon: require("../assets/system/emergency.png"),
          href: ""
        },
        {
          name: "校园电器设备故障自动检测系统",
          intro: "通过物联网技术把各系统设备在故障临介状态就发出故障报警",
          icon: require("../assets/system/electrical.png"),
          href: ""
        },
        {
          name: "校园场室照明自动感光控制系统",
          intro: "按光亮度自动调节光源，比传统光管照明节电50％",
          icon: require("../assets/system/lighting.png"),
          href: ""
        },
        {
          name: "课室讲坛装备系统",
          intro: "平面机，蓝牙，音频处理，视频处理，互动板书写，多屏显示等系统",
          icon: require("../assets/system/pulpit.png"),
          href: ""
        },
        {
          name: "校园智能广播系统",
          intro: "网络化控制智能广播",
          icon: require("../assets/system/radio.png"),
          href: ""
        },
        {
          name: "校园视频自动播放系统",
          intro: "自动播放控制台，一键播放一组课室内终端显示器",
          icon: require("../assets/system/video.png"),
          href: ""
        },
        {
          name: "智能闭路视频监控系统",
          intro:
            "全采用数字信号经校园光纤网络传输，与人脸识系统,课室，录播系统，数据中心库联网",
          icon: require("../assets/system/videoMonitoring.png"),
          href: ""
        },
        {
          name: "校园红外安防报警系统",
          intro: "安装后当有人闯入校园时，有声音及发出红外报警",
          icon: require("../assets/system/infraredDetection.png"),
          href: ""
        },
        {
          name: "消防设备故障自动检测报警系统",
          intro: "消防水喉的水压，喷淋水嘴的失效，消防箱的损坏等，发出警告语声",
          icon: require("../assets/system/fire.png"),
          href: ""
        },
        {
          name: "智能马桶",
          intro: "自动感应冲水",
          icon: require("../assets/system/closestool.png"),
          href: ""
        },
        {
          name: "智慧学生书卓系统",
          intro: "提醒学生坐姿,收拾书包等及电脑充电",
          icon: require("../assets/system/desk.png"),
          href: ""
        }
      ]
    };
  },
  methods: {},
  mounted() {
    var self = this;
    $.ajax({
      url: "/plans.php",
      type: "get",
      data: null,
      headers: {
        "Content-Type": "application/json"
      },
      success: function(data, textStatus, jqXHR) {
        var data = JSON.parse(data);
        console.log(data);
        self.plans = data.plans;
      },
      error(jqXHR, status, errormsg) {}
    });
  }
};

/** 暂无图标
 * 课室智能消毒，灭蚊系统
 * 校园特别情况应急处理系统
 */
</script>








// WEBPACK FOOTER //
// src/components/system.vue